import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const RolesContext = createContext(null);

type Props = {
  children: ReactElement;
};

const RolesProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["roles"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`settings/roles`);

      return data;
    },
  });

  const {
    data: PremblyRolesData,
    isLoading: isLoadingPremblyRoles,
    error: PremblyRolesError,
    isFetching: isFetchingPremblyRoles,
  } = useQuery({
    queryKey: ["prembly_roles"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`settings/prembly-roles`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
      PremblyRolesData,
      isLoadingPremblyRoles,
      PremblyRolesError,
      isFetchingPremblyRoles,
      error,
    }),
    [
      isLoading,
      data,
      error,
      isFetching,
      PremblyRolesData,
      isLoadingPremblyRoles,
      PremblyRolesError,
      isFetchingPremblyRoles,
    ],
  );
  return (
    <RolesContext.Provider value={contextValue}>
      {children}
    </RolesContext.Provider>
  );
};

export default RolesProvider;
